export const environment = {
  production: true,
  datadog: {
    clientToken: 'pub5decdc529b4105e04fbf2d7c226546a0',
    applicationId: '9d7d6d9e-e1f6-4bb1-ba84-0dc851b48bbb',
    env: 'nomadic-prod',
    site: 'datadoghq.com',
  },
};



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/environments/environment.ts